<template lang="pug">
    .reaction-wrapper
        form
            Reaction(
                v-for="reaction in reactions" 
                v-if="reaction.input_type != 'nextInformation'"
                :key="reaction.id"
                :answer="answer"
                :reaction="reaction"
                :information="information"
                :answered="answered"
                :section="section"
            )
</template>
<script>
import _ from 'lodash'

import Heading from './Heading'
import PostImage from './PostImage'
import Reaction from './Reaction'


export default {
    name: 'Reactions',
    components: {
        Heading,
        PostImage,
        Reaction
    },
    data() {
        return {
            answer: undefined
        }
    },
    props: {
        reactions: {
           type: Array,
           required: true
        },
        information: {
            type: Object,
            required: true
        },
        answered: {
            type: Boolean
        },
        section: {
            type: Object,
            required: true
        },
    }
}
</script>
<style lang="sass">

</style>
